<script>
import axios from "axios";
import api from "@/repo/api";

export default {
    props: {
        title: {
            type: String,
            default: '导出'
        },
        url: {
            type: String,
            default: ''
        },
        query: {
            type: Object,
            default: () => {
            }
        }
    },
    methods: {
        exportList() {
            
            this.$loading.show()
            
            axios.post(api.colUrl(this.url), this.query, {
                responseType: 'arraybuffer'
            }).then((response) => {
                
                this.$loading.hide()
                
                if (response.headers['content-type'] == 'application/json') {
                    
                    const uint8Array = new Uint8Array(response.data);
                    
                    const textDecoder = new TextDecoder('utf-8');
                    const jsonString = textDecoder.decode(uint8Array);
                    
                    const jsonData = JSON.parse(jsonString);
                    
                    this.$message.data(jsonData)
                    
                    return
                }
                
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'] || 'application/vnd.ms-excel'
                });
                const blobUrl = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = this.title;
                link.click();
                URL.revokeObjectURL(blobUrl);
                
            })
        },
    }
}
</script>

<template>
    <button class="btn" @click="exportList">下载全部</button>
</template>

<style scoped lang="less">

</style>